
define('template!portalUsersTpl', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="well portal-users-page">\n\n  <!-- Account-wide, so it sits above the supplier picker rather than inside it. -->\n  <div class="js-imports"></div>\n\n  <!-- The one list that comes to the operator: a supplier asked something. -->\n  <div class="js-waiting"></div>\n\n  <!-- Answers "who is live" before anyone has to pick a supplier. -->\n  <div class="js-overview"></div>\n\n  <div class="portal-users-header">\n    <div class="form-group supplier-picker">\n      <label for="portal-users-supplier">' +
((__t = ( _.i18n('portalUsers.supplier', null, 'Supplier') )) == null ? '' : __t) +
'</label>\n      <select id="portal-users-supplier" class="form-control js-supplier">\n        ';
 if (suppliers.length === 0) { ;
__p += '\n          <option value="">' +
((__t = ( _.i18n('portalUsers.noSuppliers', null, 'No suppliers shared with this account') )) == null ? '' : __t) +
'</option>\n        ';
 } ;
__p += '\n        ';
 _.each(suppliers, function (supplier) { ;
__p += '\n          <option value="' +
((__t = ( supplier.secId )) == null ? '' : __t) +
'">' +
((__t = ( supplier.code )) == null ? '' : __t) +
' — ' +
((__t = ( supplier.name )) == null ? '' : __t) +
'</option>\n        ';
 }); ;
__p += '\n      </select>\n    </div>\n\n    <div class="btn add-btn-text js-add-user">\n      <i class="mdi-content-add icon"></i>\n      <span>' +
((__t = ( _.i18n('portalUsers.new', null, 'New portal account') )) == null ? '' : __t) +
'</span>\n    </div>\n  </div>\n\n  <div class="js-routing"></div>\n\n  <div class="portal-users-list js-list"></div>\n\n  <!-- Having given someone a login, is anything actually waiting on them? -->\n  <div class="js-orders"></div>\n</div>\n';

}
return __p
};});

